import { Component, OnInit } from '@angular/core'

@Component({
  selector: 'app-admin-register-devtpartner',
  templateUrl: './admin-register-devtpartner.component.html',
  styleUrls: ['./admin-register-devtpartner.component.scss'],
})
export class AdminRegisterDevtpartnerComponent {}
